import copy from 'copy-to-clipboard';
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['message'];

  static values = {
    copy: String
  };

  copy() {
    copy(this.copyValue);

    if (this.hasMessageTarget) {
      this.messageTarget.classList.remove('opacity-0');
      setTimeout(() => {
        this.messageTarget.classList.add('opacity-0');
      }, 3000);
    }
  }
}
